module.exports = __webpack_public_path__ + "static/img/13.a24a130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13.png
// module id = 6UKO
// module chunks = 0